import { render, staticRenderFns } from "./UserActionInfoSetPlayerInventoryItemAmount.vue?vue&type=template&id=2946dc3a&"
import script from "./UserActionInfoSetPlayerInventoryItemAmount.vue?vue&type=script&lang=js&"
export * from "./UserActionInfoSetPlayerInventoryItemAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports